import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Row,
  Tab,
  Nav,
  Carousel,
  Modal,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { IMAGES } from "../../../assets/images/images";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { aminitiesIcon } from "../../../utility/local/constants";
import { DateRangePicker } from "react-date-range";
import {
  BookProperty,
  checkAvailabilyAndGetPrice,
  GetPropertyReviews,
  viewProperty,
} from "../../../utility/apiServices/userServices";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from "sweetalert2";
import { format, addDays } from "date-fns";
import PropertyLocationMap from "../../../components/maps/locationMarker";
import { isAuthenticated, isHost, isUser } from "../../../utility/auth";
import { MyModel } from "../../../components/customcomponents/customradiobutton/Model";
import {
  checkAvailabilityAndCalculatePrice,
  description,
  descriptionList,
  formatRating,
  formatValues,
  Long_Des,
  Longdescription,
} from "../../../utility/local/functions/crypto";
import { useTranslation } from "react-i18next";
export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getUTCDate();
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  const formattedDate = `${day} ${month} ${year}`;
  return formattedDate;
};

const PropertyDetailScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const propertyData = location?.state?.data;
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (!propertyData) {
      navigate("/");
    }
  }, [propertyData]);

  useEffect(() => {
    const propertyLocation = {
      lat: propertyData?.latitude || 0,
      lng: propertyData?.longitude || 0,
    };
    setpropertyLocation(propertyLocation);
  }, [propertyData]);

  // const [rating, setRating] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [availabiltyDataAndRates, setavailabiltyDataAndRates] = useState();
  const [availabiltyLoading, setavailabiltyLoading] = useState(false);
  const [isBooking, setisBooking] = useState(false);
  const [isAvailableForBooking, setisAvailableForBooking] = useState(false);
  const [reviews, setreviews] = useState([]);
  const [reviewsLimit, setReviewsLimit] = useState([]);
  const [reviewData, setreviewData] = useState([]);
  const [reviewsPage, setreviewsPage] = useState(1);
  const [referralCodee, setreferralCodee] = useState("");
  const [propertyLocation, setpropertyLocation] = useState({ lat: 0, lng: 0 });
  const [reportModel, setReportModel] = useState(false);
  const [showLoginHostBnt, setShowLoginHostBtn] = useState(false);
  const [accountAlert, setAccountAlert] = useState(false);
  const [f, setf] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    navigate("/reviewList", {
      state: { property: propertyData },
    });
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 1),
    key: "selection",
  });

  useEffect(() => {
    if (propertyData?.id) {
      getreviews();
    } else {
      navigate("/");
    }
  }, []);

  function checkUser(propertyData) {
    const userEmail = localStorage.getItem("email");
    if (propertyData.email === userEmail) {
      return true;
    }
    return false;
  }
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (checkUser(propertyData)) {
      setShowLoginHostBtn(true);
    } else {
      setShowLoginHostBtn(false);
    }
  }, [propertyData]);
  const getreviews = async () => {
    let response = await GetPropertyReviews(propertyData.id, reviewsPage);
    if (response?.status) {
      setreviews([...reviews, ...response?.reviews]);
      var displayedReviews =
        response?.reviews.length > 0 && response?.reviews.length < 3
          ? response?.reviews
          : response?.reviews.slice(0, 3);
      setReviewsLimit([...displayedReviews]);
      setIsExpandedReview(
        [...reviews, ...response?.reviews].map((val, index) => false)
      );
      setreviewData(response);
    }
  };

  const confirmBooking = async (
    discount_code,
    applyCouponPrice,
    totalAmount
  ) => {
    setisBooking(true);
    const createBooking = await BookProperty({
      propertyId: propertyData.id,
      startDate: format(selectionRange.startDate, "yyyy-MM-dd"),
      endDate: format(selectionRange.endDate, "yyyy-MM-dd"),
      discountCode: discount_code || 0,
      referralCode: referralCodee,
      discountPrice: applyCouponPrice || 0,
      totalAmount: totalAmount,
    });

    if (createBooking?.status) {
      Swal.fire({
        icon: "success",
        text: t("success_msg_booking") || "",
      }).then((result) => {
        setisBooking(false);
        setreferralCodee("");
        if (result.isConfirmed) {
          navigate("/mybooking");
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        text:
          createBooking?.message ||
          "Something went wrong! Please try again later",
      });
    }
    setisBooking(false);
  };

  const getDateforProperty = async (refCode = null) => {
    try {
      setavailabiltyLoading(true);
      let data = {
        propertyId: propertyData?.id,
        checkInDate: format(selectionRange.startDate, "yyyy-MM-dd"),
        checkOutDate: format(selectionRange.endDate, "yyyy-MM-dd"),
        referralCode: refCode == null ? referralCodee : refCode,
      };
      const response = await checkAvailabilyAndGetPrice(data);
      if (response.status) {
        if (response.isAvailable) {
          setavailabiltyDataAndRates(response);
          setisAvailableForBooking(true);
        } else {
          setisAvailableForBooking(false);
          setavailabiltyDataAndRates(response);
        }
      } else {
        setisAvailableForBooking(false);
      }
      setavailabiltyLoading(false);
    } catch (err) {
      setavailabiltyLoading(false);
      console.log("err :", err);
    }
  };

  useEffect(() => {
    if (!selectionRange) return;
    getDateforProperty();
  }, [selectionRange]);

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };
  // const handleStarClick = (clickedIndex) => {
  //   setRating(clickedIndex + 1);
  // };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  //MARK: ADD view
  useEffect(() => {
    viewProperty({ propertyId: propertyData.id });
  }, [propertyData.id]);

  const [isExpandedReview, setIsExpandedReview] = useState([]);

  const handleToggleDescription = (index) => {
    setIsExpandedReview((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const currentLanguage = i18n.language;

  return (
    <React.Fragment>
      <section className="commonpad">
        <Container fluid>
          <Row className="mb-4">
            <Col md={12}>
              <div className="propertyHeader">
                <div className="propertyHeader_left">
                  <h2>{descriptionList(propertyData?.short_description, propertyData?.short_description_hebrew, currentLanguage, 75)}</h2>
                  <h3>
                    <Icon icon="system-uicons:location" />
                    <span style={{ maxWidth: "700px" }}>
                      {" "}
                      {propertyData?.area} {propertyData?.street_address}{" "}
                    </span>

                    <span className="divider">|</span>
                    <span className="pro_phone">
                      <Icon icon="flat-color-icons:phone" />{" "}
                      {propertyData?.phone_number}
                    </span>
                  </h3>

                  <div className="mb-4 hideMobile">
                    <div className="room-tabs" variant="pills">
                      {propertyData?.rooms?.map((room, index) => (
                        <div key={index} className="room-tab-item">
                          <div
                            className={`room-tab-link ${activeTab === index ? "active" : ""
                              }`}
                            onClick={() => handleTabClick(index)}
                          >
                            {t("propertyDetail.room")} {index + 1}
                          </div>
                        </div>
                      ))}
                      <div
                        className="slider-bar"
                        style={{
                          transform: `translateX(${activeTab * 100}%)`,
                        }}
                      />
                    </div>
                  </div>

                  <Row className="mb-4">
                    <Col md={12}>
                      <div className="property-details">
                        {propertyData?.rooms.length > 0 && (
                          <div className="propertyHeader_bSizes">
                            <h4>
                              <Icon
                                size={25}
                                color="#1b91bf"
                                icon="mdi:home-city-outline"
                                style={{ width: 25, height: 25 }}
                              />
                              {/* {console.log(propertyData, 'console  data --')} */}
                              {t("filter.propertyType")}:{" "}
                              {
                                currentLanguage === "he" ? propertyData?.property_type :
                                  propertyData?.property_type
                              }

                              <span>|</span>
                              <Image
                                src={IMAGES.Bed_Img}
                                alt=""
                                style={{ width: 25, height: 25 }}
                              />
                              {t("propertyDetail.beds")}:{" "}
                              {propertyData?.rooms[activeTab]?.numberOfBeds}
                              <span>|</span>
                              <Image
                                src={IMAGES.Guests_Img}
                                alt=""
                                style={{ width: 27, height: 27 }}
                              />
                              {t("propertyDetail.guests")}:{" "}
                              {propertyData?.rooms[activeTab]?.adults +
                                propertyData?.rooms[activeTab]?.children}
                              <span>|</span>
                              <Image
                                src={IMAGES.M2_Img}
                                alt=""
                                style={{ width: 20, height: 20 }}
                              />
                              {t("propertyDetail.size")}:{" "}
                              {propertyData?.rooms[activeTab]?.size} sqm
                              <span>|</span>
                              <Icon
                                size={25}
                                color="#1b91bf"
                                icon="mdi:home-outline"
                                style={{ width: 30, height: 30 }}
                              />
                              {t("propertyDetail.flatSuit")}:{" "}
                              {propertyData?.flat_suite}
                            </h4>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="propertyHeader_right">
                  <div className="star-rating align-items-center">
                    {[
                      ...Array(
                        reviewData?.averageRating
                          ? Math.floor(reviewData?.averageRating)
                          : 0
                      ),
                    ].map((_, index) => (
                      <Icon key={index} icon="ph:star-fill" color="#E1C03F" />
                    ))}
                    {[
                      ...Array(
                        5 -
                        (reviewData?.averageRating
                          ? Math.floor(reviewData?.averageRating)
                          : 0)
                      ),
                    ].map((_, index) => (
                      <Icon key={index} icon="ph:star" color="#E1C03F" />
                    ))}
                    <span>
                      {formatRating(reviewData?.averageRating)} (
                      {reviewData?.totalResults}{" "}
                      {reviews?.length > 1 ? `reviews` : `review`})
                    </span>
                  </div>
                  <h3>
                    <Icon icon="solar:eye-outline" />{" "}
                    {reviewData?.viewCount || 0}
                  </h3>
                </div>
              </div>
            </Col>
          </Row>

          <div className="sliderProperty">
            <Carousel>
              {(() => {
                const flattenedImages = (() => {
                  if (Array.isArray(propertyData?.images)) {
                    return propertyData.images.flatMap(item => {
                      if (typeof item === 'string') return item;
                      if (typeof item === 'object' && item !== null) {
                        return Object.values(item).flatMap(roomImages =>
                          Array.isArray(roomImages) ? roomImages.map(img => img?.location || img) : []
                        );
                      }
                      return [];
                    });
                  }
                  return [];
                })();

                return flattenedImages.length > 0 ? flattenedImages.map((image, index) => (
                  <Carousel.Item key={index}>
                    <div
                      className="listImage"
                      style={{ backgroundImage: `url(${image})` }}
                    ></div>
                  </Carousel.Item>
                )) : (
                  <Carousel.Item>
                    <div
                      className="listImage"
                      style={{ backgroundImage: `url(${IMAGES.PlaceHolderImage})`, backgroundColor: '#f0f0f0' }}
                    ></div>
                  </Carousel.Item>
                );
              })()}
            </Carousel>
          </div>

          <Row className="mb-4 hideMobile">
            <Col md={12}>
              <Tab.Container id="left-tabs-example" defaultActiveKey={0}>
                <Row>
                  <Col md={12}>
                    <div className="tab_flex">
                      <Tab.Content style={{ width: "85%" }}>
                        {(() => {
                          const flattenedImages = (() => {
                            if (Array.isArray(propertyData?.images)) {
                              return propertyData.images.flatMap(item => {
                                if (typeof item === 'string') return item;
                                if (typeof item === 'object' && item !== null) {
                                  return Object.values(item).flatMap(roomImages =>
                                    Array.isArray(roomImages) ? roomImages.map(img => img?.location || img) : []
                                  );
                                }
                                return [];
                              });
                            }
                            return [];
                          })();

                          return flattenedImages.map((image, index) => (
                            <Tab.Pane eventKey={index} key={index}>
                              <div className="productSection__imagepreview">
                                <Image alt="" src={image} />
                              </div>
                            </Tab.Pane>
                          ));
                        })()}
                      </Tab.Content>
                      <Nav variant="pills" style={{ width: "15%" }}>
                        <Swiper
                          modules={[Navigation]}
                          direction="vertical"
                          slidesPerView="4"
                          mousewheel={true}
                          navigation={true}
                          speed={1200}
                          onSwiper={(swiper) => console.log(swiper)}
                          onSlideChange={() => console.log("slide change")}
                        >
                          {(() => {
                            const flattenedImages = (() => {
                              if (Array.isArray(propertyData?.images)) {
                                return propertyData.images.flatMap(item => {
                                  if (typeof item === 'string') return item;
                                  if (typeof item === 'object' && item !== null) {
                                    return Object.values(item).flatMap(roomImages =>
                                      Array.isArray(roomImages) ? roomImages.map(img => img?.location || img) : []
                                    );
                                  }
                                  return [];
                                });
                              }
                              return [];
                            })();

                            return flattenedImages.map((image, index) => (
                              <SwiperSlide key={index}>
                                <Nav.Item>
                                  <Nav.Link eventKey={index}>
                                    <Image
                                      alt=""
                                      src={image}
                                      className="img-fluid"
                                    />
                                  </Nav.Link>
                                </Nav.Item>
                              </SwiperSlide>
                            ));
                          })()}
                        </Swiper>
                      </Nav>
                    </div>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>

          <Row className="mb-4 hideMobile">
            <Col lg={8}>
              <div className="prop_desc">
                <h2>{t("propertyDetail.description")}</h2>
                {/* <p className="decs_para">{propertyData?.long_description}</p> */}
                <p>
                  {propertyData?.long_description && isExpanded
                    ? Long_Des(propertyData?.long_description, propertyData?.long_description_hebrew, currentLanguage, 501)
                    : Long_Des(propertyData?.long_description, propertyData?.long_description_hebrew, currentLanguage, 500)
                  }
                  {propertyData?.long_description && (
                    <button
                      style={{
                        border: "none",
                        background: "none",
                        color: "blue",
                      }}
                      onClick={() => handleToggle()}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </p>

                <div className="modal_Header">
                  <h2>{t("propertyDetail.facilities")}</h2>
                  {/* <Link className="showAll">Show More</Link> */}
                </div>

                <ul className="pro_category">
                  {propertyData?.facilities?.map((amenity, index) => (
                    <li key={index}>
                      <Icon
                        key={index}
                        icon={aminitiesIcon[amenity]}
                        width={25}
                        height={25}
                        color="#1b91bf"
                        style={{ marginRight: "5px" }}
                      />
                      {amenity}
                    </li>
                  ))}
                </ul>

                {/* <div className="modal_Header">
                  <h2>{t("propertyDetail.facilities")}</h2>
                </div>

                <ul className="pro_category">
                  {propertyData?.facilities?.map((val, index) => (
                    <li>
                      <img
                        src={val?.imageUrl}
                        width={25}
                        height={27}
                        style={{ marginRight: "5px" }}
                      />
                      {val?.engname}
                    </li>
                  ))}
                </ul> */}

                <div className="modal_Header">
                  <h2>{t("propertyDetail.guestsDetail")}</h2>
                </div>
                {/* <Link className="showAll">Show More</Link> */}
                <ul className="pro_category">
                  {/* {propertyData?.rooms} */}
                  <li>
                    {t("filter.adults")} :{" "}
                    <span>{propertyData?.rooms[activeTab]?.adults || 0}</span>
                  </li>
                  <li>
                    {t("filter.children")} :{" "}
                    <span>{propertyData?.rooms[activeTab]?.children || 0}</span>
                  </li>
                  <li>
                    {t("filter.pets")} :{" "}
                    <span>{propertyData?.rooms[activeTab]?.pets || 0}</span>
                  </li>
                </ul>

                {propertyData?.is_available_for_booking == "reserving" && (
                  <>
                    <h2>{t("propertyDetail.availabilities")}</h2>
                    <div className="mb-4 mt-3">
                      <div className="date-range-container2 date-range-positionrel">
                        <DateRangePicker
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                          months={2}
                          minDate={new Date()}
                          disabledDates={reviewData?.reservedDates}
                          direction="horizontal"
                          moveRangeOnFirstSelection={false}
                        />
                      </div>
                    </div>
                  </>
                )}

                {reviews?.length ? (
                  <>
                    <div className="modal_Header">
                      <h2>  {t("propertyDetail.reviews")} ({reviews.length})</h2>
                      {reviews.length > 1 ? (
                        <button
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "none",
                          }}
                          onClick={() => handleButtonClick()}
                          className="showAll"
                        >
                          {t("propertyDetail.seeAll")}
                        </button>
                      ) : null}
                    </div>
                    <ul className="flexReview">
                      {reviews?.length > 0 ? (
                        reviews.length > 0 &&
                        reviewsLimit.map((review, index) => {
                          const description = review?.description || "";
                          const truncatedDescription =
                            description.length > 150 && !isExpandedReview[index]
                              ? description.substring(0, 150) + "..."
                              : description;
                          return (
                            <li key={review.id}>
                              <Image
                                src={
                                  review?.User?.profile_url ||
                                  IMAGES.PlaceHolderUserImage
                                }
                                alt=""
                              />
                              <div>
                                <div className="mediaFlex">
                                  <div>
                                    <h3>{review?.User?.name}</h3>
                                    <div className="starRating">
                                      {[...Array(review?.rating)].map(
                                        (_, index) => (
                                          <Icon
                                            key={index}
                                            icon="ph:star-fill"
                                            color="#E1C03F"
                                          />
                                        )
                                      )}
                                      {[...Array(5 - review?.rating)].map(
                                        (_, index) => (
                                          <Icon
                                            key={index}
                                            icon="ph:star"
                                            color="#E1C03F"
                                          />
                                        )
                                      )}
                                      <span className="starCount">
                                        {review?.rating}
                                      </span>
                                    </div>
                                  </div>
                                  <span className="times">
                                    {formatDate(review?.createdAt)}
                                  </span>
                                </div>
                                <p>
                                  {truncatedDescription}
                                  {description.length > 150 && (
                                    <span
                                      onClick={() =>
                                        handleToggleDescription(index)
                                      }
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {isExpandedReview[index]
                                        ? t("propertyDetail.ReadLess")
                                        : t("propertyDetail.readMore")}
                                    </span>
                                  )}
                                </p>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </ul>
                  </>
                ) : null}

                {/* <h2>Write Your Review</h2>
                <h5>Your Rating</h5>
                <div className="star-rating">
                  {[...Array(5)].map((_, index) => (
                    <span
                      key={index}
                      className={index < rating ? "star filled" : "star"}
                      onClick={() => handleStarClick(index)}
                    >
                      <Icon icon="ph:star" fontSize={20} />
                    </span>
                  ))}
                </div>
                <h5>Your Review</h5>
                <Form.Control
                  className="mb-4"
                  rows={5}
                  as="textarea"
                  placeholder="Write a review"
                  aria-label="With textarea"
                />
                <Button>Post a Review</Button> */}
              </div>
            </Col>
            <Col lg={4}>
              {propertyData?.is_available_for_booking == "reserving" ? (
                <>
                  <div className="property_Shadow">
                    {availabiltyLoading ? (
                      <>
                        <Skeleton height={20} />
                        <Skeleton height={20} width={"20%"} />
                        <div className="divider"></div>

                        <Skeleton height={20} />
                        <Skeleton height={20} width={"20%"} />
                        <div className="divider"></div>

                        <Skeleton height={20} />
                        <Skeleton height={20} />
                      </>
                    ) : (
                      <>
                        <h2>{t("propertyDetail.weekendsPrice")}</h2>
                        {propertyData?.weekend_discounted_price ? (
                          <h3>
                            $
                            {formatValues(
                              propertyData?.weekend_discounted_price
                            )}{" "}
                            <small>
                              <span>
                                $
                                {formatValues(propertyData?.price_for_weekends)}
                              </span>{" "}
                              {t("propertyDetail.perNight")}
                            </small>{" "}
                          </h3>
                        ) : (
                          `$${formatValues(propertyData?.price_for_weekends)}`
                        )}

                        <div className="divider"></div>
                        <h2>{t("propertyDetail.WeekdaysPrice")}</h2>
                        {propertyData?.weekdays_discounted_price ? (
                          <h3>
                            $
                            {formatValues(
                              propertyData?.weekdays_discounted_price
                            )}{" "}
                            <small>
                              <span>
                                $
                                {formatValues(propertyData?.price_for_weekdays)}
                              </span>{" "}
                              {t("propertyDetail.perNight")}
                            </small>{" "}
                          </h3>
                        ) : (
                          `$${propertyData?.price_for_weekdays}`
                        )}
                        <div className="divider"></div>

                        {availabiltyDataAndRates?.appliedCoupon
                          ?.discount_price > 0 ? (
                          <h4 className="offText">{`${availabiltyDataAndRates?.appliedCoupon
                            ?.discount_type == "Flat"
                            ? "$" +
                            availabiltyDataAndRates?.appliedCoupon
                              ?.discount_price
                            : availabiltyDataAndRates?.appliedCoupon
                              ?.discount_price + "%"
                            } off with ${availabiltyDataAndRates?.appliedCoupon?.discountCode
                            } till ${formatDate(
                              availabiltyDataAndRates?.appliedCoupon?.end_date
                            )}. ${availabiltyDataAndRates?.appliedCoupon
                              ?.discount_type == "Percentage"
                              ? "Save $" +
                              availabiltyDataAndRates?.appliedCoupon
                                .discountAmount
                              : ""
                            }`}</h4>
                        ) : null}

                        {!isHost() && isAuthenticated() && (
                          <>
                            {availabiltyDataAndRates?.appliedCoupon
                              ?.discount_price > 0 ? (
                              <div className="divider"></div>
                            ) : null}
                            <label>
                              {t("propertyDetail.DoYouhaveAnyReferralCode")}
                            </label>
                            <div className="d-flex">
                              <Form.Control
                                type="text"
                                placeholder="Enter Referral code"
                                className="inputNormal"
                                value={referralCodee}
                                autoCapitalize={true}
                                onChange={(e) =>
                                  setreferralCodee(e.target.value)
                                }
                                style={{ height: 50 }}
                              ></Form.Control>
                              <Button
                                variant="primary"
                                className="mx-2"
                                onClick={() => {
                                  getDateforProperty();
                                }}
                              >
                                {t("propertyDetail.apply")}
                              </Button>
                            </div>

                            <div
                              className={
                                availabiltyDataAndRates?.appliedReferral
                                  ?.discountAmount > 0
                                  ? "successMessage2"
                                  : "errorStyle"
                              }
                            >
                              {referralCodee &&
                                availabiltyDataAndRates?.appliedReferral
                                  ?.message}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>

                  <div className="property_Shadow property_Shadow1 property_Shadow1Flex">
                    {availabiltyLoading ? (
                      <>
                        <div className="d-flex w-100 mb-2 justify-content-between">
                          <Skeleton height={20} width={100} />
                          <Skeleton height={20} width={100} />
                        </div>

                        <Skeleton height={50} />
                        <div className="" style={{ height: "50px" }}></div>

                        <Skeleton height={20} />
                        <Skeleton height={20} width={"20%"} />

                        <Skeleton height={20} />
                        <div className="divider"></div>
                        <Skeleton height={20} />
                      </>
                    ) : (
                      <>
                        <div className="pFlex">
                          <h3 className="ph3">
                            ${availabiltyDataAndRates?.pricePerNight}{" "}
                            <span> / {t("propertyDetail.night")}</span>
                          </h3>
                          <div className="pFlexStar">
                            <Icon
                              icon="ph:star"
                              color="#1B91BF"
                              fontSize={20}
                            />
                            {formatRating(reviewData?.averageRating)}
                            <span className=""></span>{" "}
                            {/* {reviews?.length > 1
                              ? `${reviews?.length} reviews`
                              : `${reviews?.length} review`} */}
                          </div>
                        </div>
                        {!isHost() && isAuthenticated() ? (
                          <>
                            <Button
                              className="w-100"
                              onClick={() => {
                                confirmBooking(
                                  availabiltyDataAndRates?.appliedCoupon
                                    ?.discountId,
                                  availabiltyDataAndRates?.appliedCoupon
                                    ?.discountAmount,
                                  availabiltyDataAndRates?.totalAmount.toFixed(
                                    2
                                  )
                                );
                              }}
                              disabled={!isAvailableForBooking || isBooking}
                            >
                              {isBooking ? "Reserving" : "Reserve"}
                            </Button>
                            {!isAvailableForBooking && (
                              <p className="text-start errorStyle">
                                {t("propertyDetail.PropertyNotAvailable")}
                              </p>
                            )}
                          </>
                        ) : (
                          <>
                            {isHost() && (
                              <>
                                {" "}
                                <Button
                                  className="w-100"
                                  onClick={() => setAccountAlert(true)}
                                >
                                  {t("propertyDetail.LoginToReserve")}
                                </Button>
                                {!isAvailableForBooking && (
                                  <p className="text-start errorStyle">
                                    {t("propertyDetail.PropertyNotAvailable")}
                                  </p>
                                )}
                              </>
                            )}
                            {!isHost() && (
                              <>
                                {" "}
                                <Button
                                  className="w-100"
                                  as={Link}
                                  to={"/login"}
                                >
                                  {t("propertyDetail.LoginToReserve")}
                                </Button>
                                {!isAvailableForBooking && (
                                  <p className="text-start errorStyle">
                                    {t("propertyDetail.PropertyNotAvailable")}
                                  </p>
                                )}
                              </>
                            )}
                          </>
                        )}

                        <p className="text-center">{t("propertyDetail.Youwon’tBeChargedYet")}</p>
                        <h5>
                          {
                            currentLanguage === "he" ?
                              <strong dir="rtl" style={{ unicodeBidi: "embed", direction: "rtl" }}>
                                {t("propertyDetail.nights")} {availabiltyDataAndRates?.totalDays} ×{" "}
                                {availabiltyDataAndRates?.pricePerNight}
                              </strong>
                              :
                              <strong>
                                ${availabiltyDataAndRates?.pricePerNight} x{" "}
                                {availabiltyDataAndRates?.totalDays} {t("propertyDetail.nights")}
                              </strong>
                          }




                          <span>
                            $
                            {formatValues(
                              availabiltyDataAndRates?.originalAmount
                            )}
                          </span>
                        </h5>
                        <h5>
                          <strong>{t("propertyDetail.OfferedDiscount")}</strong>
                          <span className="minus">
                            -$
                            {
                              //  && availabiltyDataAndRates?.discount_type == ""
                              availabiltyDataAndRates?.appliedCoupon
                                ?.discountAmount || 0
                            }
                          </span>
                        </h5>

                        {availabiltyDataAndRates?.appliedReferral
                          ?.discountAmount > 0 && (
                            <h5>
                              <strong>
                                {t("propertyDetail.ReferralDiscount")}{" "}
                                <button
                                  onClick={() => {
                                    setreferralCodee("");
                                    setf(!f);
                                    setTimeout(() => {
                                      getDateforProperty("");
                                    }, 100);
                                  }}
                                  style={{
                                    border: "none",
                                    marginBottom: "20px !important",
                                    outline: "none",
                                    backgroundColor: "transparent",
                                    color: "red",
                                  }}
                                >
                                  <Icon
                                    fontSize={20}
                                    icon="mdi:trash"
                                    color="red"
                                  />
                                </button>{" "}
                              </strong>
                              <span className="minus">
                                -$
                                {formatRating(
                                  availabiltyDataAndRates?.appliedReferral
                                    ?.discountAmount
                                ) || 0}
                              </span>
                            </h5>
                          )}

                        <div className="divider"></div>
                        <h5 className="mb-0">
                          <strong>{t("propertyDetail.Total")}</strong>
                          <span>
                            ${availabiltyDataAndRates?.totalAmount.toFixed(2)}
                          </span>
                        </h5>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="property_Shadow property_Shadow1">
                    <h2 className="text-center">
                      {t("propertyDetail.PropertyReserved")}
                    </h2>
                    <p className="text-center">
                      {" "}
                      {t("propertyDetail.ContactOwner")}
                    </p>
                    <Button
                      className="w-80 text-center m-auto"
                      style={{ width: "80%" }}
                      onClick={() =>
                      (window.location.href =
                        "mailto:support@lanim.com?subject=Subject&body=Your message here")
                      }
                    >
                      {t("propertyDetail.ContactNow")}
                    </Button>

                    <h5 className="mt-3">
                      <strong>{t("propertyDetail.mobile")}</strong>
                      <span
                        className="minus"
                        style={{
                          position: "relative",
                          left: -3,
                        }}
                      >
                        {propertyData?.phone_number}
                      </span>
                    </h5>

                    <h5>
                      <strong>{t("propertyDetail.email")}</strong>
                      <span className="minus">
                        {localStorage.getItem("email") || "--"}
                      </span>
                    </h5>
                  </div>
                </>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span />
                {isAuthenticated() && (
                  <a
                    onClick={() => {
                      setReportModel(true);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      textAlign: "center",
                    }}
                    className="reportText"
                  >
                    <Icon
                      fontSize={20}
                      icon="solar:flag-2-linear"
                      color="#1B91BF"
                    />
                    <span>{t("propertyDetail.ReportListing")}</span>
                  </a>
                )}
                <span />
              </div>
            </Col>
          </Row>

          <Row className="mb-4 mobilColReverse">
            <Col lg={8}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span />
                {isAuthenticated() && (
                  <a
                    onClick={() => {
                      setReportModel(true);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      textAlign: "center",
                    }}
                    className="reportText"
                  >
                    <Icon
                      fontSize={20}
                      icon="solar:flag-2-linear"
                      color="#1B91BF"
                    />
                    <span>{t("propertyDetail.ReportListing")}</span>
                  </a>
                )}
                <span />
              </div>
              <div className="prop_desc">
                <h2>{t("propertyDetail.description")}</h2>

                <p className="decs_para here 00">   {propertyData?.long_description && isExpanded
                  ? Long_Des(propertyData?.long_description, propertyData?.long_description_hebrew, currentLanguage, 501)
                  : Long_Des(propertyData?.long_description, propertyData?.long_description_hebrew, currentLanguage, 500)
                }</p>

                <div className="modal_Header">
                  <h2>{t("propertyDetail.facilities")}</h2>
                </div>

                <ul className="pro_category">
                  {propertyData?.facilities?.map((val, index) => (
                    <li>
                      <img src={val?.imageUrl} width={26} height={26} />
                      {val?.engname}
                    </li>
                  ))}
                </ul>
                <div className="modal_Header">
                  <h2>{t("propertyDetail.guestsDetail")}</h2>
                </div>
                {/* <Link className="showAll">Show More</Link> */}
                <ul className="pro_category">
                  {/* {propertyData?.rooms} */}
                  <li>
                    {t("propertyDetail.adults")} :{" "}
                    <span>{propertyData?.rooms[activeTab]?.adults || 0}</span>
                  </li>
                  <li>
                    {t("propertyDetail.children")} :{" "}
                    <span>{propertyData?.rooms[activeTab]?.children || 0}</span>
                  </li>
                  <li>
                    {t("propertyDetail.pets")} :{" "}
                    <span>{propertyData?.rooms[activeTab]?.pets || 0}</span>
                  </li>
                </ul>

                {/* {propertyData?.is_available_for_booking == "reserving" && (
                  <>
                    <h2>Availabilities</h2>
                    <div className="mb-4 mt-3">
                      <div className="date-range-container2 date-range-positionrel">
                        <DateRangePicker
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                          months={2}
                          minDate={new Date()}
                          disabledDates={reviewData?.reservedDates}
                          direction="vertical"
                          moveRangeOnFirstSelection={false}
                        />
                      </div>
                    </div>
                  </>
                )} */}

                <div className="modal_Header">
                  <h2>{t("propertyDetail.reviews")} ({reviews.length})</h2>
                  {reviews.length > 1 ? (
                    <button
                      style={{
                        border: "none",
                        outline: "none",
                        backgroundColor: "none",
                      }}
                      onClick={() => handleButtonClick()}
                      className="showAll"
                    >
                      {t("propertyDetail.seeAll")}
                    </button>
                  ) : null}
                </div>
                <ul className="flexReview">
                  {reviews?.length > 0 ? (
                    reviews.length > 0 &&
                    reviewsLimit.map((review, index) => {
                      const description = review?.description || "";
                      const truncatedDescription =
                        description.length > 150 && !isExpandedReview[index]
                          ? description.substring(0, 150) + "..."
                          : description;
                      return (
                        <li key={review.id}>
                          <Image
                            src={
                              review?.User?.profile_url ||
                              IMAGES.PlaceHolderUserImage
                            }
                            alt=""
                          />
                          <div>
                            <div className="mediaFlex">
                              <div>
                                <h3>{review?.User?.name}</h3>
                                <div className="starRating">
                                  {[...Array(review?.rating)].map(
                                    (_, index) => (
                                      <Icon
                                        key={index}
                                        icon="ph:star-fill"
                                        color="#E1C03F"
                                      />
                                    )
                                  )}
                                  {[...Array(5 - review?.rating)].map(
                                    (_, index) => (
                                      <Icon
                                        key={index}
                                        icon="ph:star"
                                        color="#E1C03F"
                                      />
                                    )
                                  )}
                                  <span className="starCount">
                                    {review?.rating}
                                  </span>
                                </div>
                              </div>
                              <span className="times">
                                {formatDate(review?.createdAt)}
                              </span>
                            </div>
                            <p>
                              {truncatedDescription}
                              {description.length > 150 && (
                                <span
                                  onClick={() => handleToggleDescription(index)}
                                  style={{ color: "blue", cursor: "pointer" }}
                                >
                                  {isExpandedReview[index]
                                    ? " Read less"
                                    : " Read more"}
                                </span>
                              )}
                            </p>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </ul>

                {/* <h2>Write Your Review</h2>
                <h5>Your Rating</h5>
                <div className="star-rating">
                  {[...Array(5)].map((_, index) => (
                    <span
                      key={index}
                      className={index < rating ? "star filled" : "star"}
                      onClick={() => handleStarClick(index)}
                    >
                      <Icon icon="ph:star" fontSize={20} />
                    </span>
                  ))}
                </div>
                <h5>Your Review</h5>
                <Form.Control
                  className="mb-4"
                  rows={5}
                  as="textarea"
                  placeholder="Write a review"
                  aria-label="With textarea"
                />
                <Button>Post a Review</Button> */}
              </div>
            </Col>
            {propertyData?.is_available_for_booking == "reserving" ? (
              <Col lg={4}>
                <div className="property_Shadow">
                  <div className="property_ShadowWeek">
                    <div>
                      <h2>{t("propertyDetail.weekendsPrice")}</h2>
                      {propertyData?.weekend_discounted_price ? (
                        <h3>
                          $
                          {formatValues(propertyData?.weekend_discounted_price)}{" "}
                          <small>
                            <span>
                              ${formatValues(propertyData?.price_for_weekends)}
                            </span>{" "}
                            {t("propertyDetail.perNight")}
                          </small>{" "}
                        </h3>
                      ) : (
                        `$${formatValues(propertyData?.price_for_weekends)}`
                      )}
                    </div>

                    <div>
                      <h2>{t("propertyDetail.WeekdaysPrice")}</h2>
                      {propertyData?.weekdays_discounted_price ? (
                        <h3>
                          $
                          {formatValues(
                            propertyData?.weekdays_discounted_price
                          )}{" "}
                          <small>
                            <span>
                              ${formatValues(propertyData?.price_for_weekdays)}
                            </span>{" "}
                            {t("propertyDetail.perNight")}
                          </small>{" "}
                        </h3>
                      ) : (
                        `$${formatValues(propertyData?.price_for_weekdays)}`
                      )}
                    </div>
                  </div>
                  <></>
                  <div style={{ marginTop: 10 }}>
                    {!isHost() && isAuthenticated() && (
                      <>
                        {availabiltyDataAndRates?.appliedCoupon
                          ?.discount_price > 0 ? (
                          <div className="divider"></div>
                        ) : null}
                        <label>{t("propertyDetail.DoYouhaveAnyReferralCode")}</label>
                        <div className="d-flex">
                          <Form.Control
                            type="text"
                            placeholder="Enter Referral code"
                            className="inputNormal"
                            value={referralCodee}
                            autoCapitalize={true}
                            onChange={(e) => setreferralCodee(e.target.value)}
                            style={{ height: 50 }}
                          ></Form.Control>
                          <Button
                            variant="primary"
                            className="mx-2"
                            onClick={() => {
                              getDateforProperty();
                            }}
                          >
                            {t("propertyDetail.apply")}
                          </Button>
                        </div>

                        <div
                          className={
                            availabiltyDataAndRates?.appliedReferral
                              ?.discountAmount > 0
                              ? "successMessage2"
                              : "errorStyle"
                          }
                        >
                          {referralCodee &&
                            availabiltyDataAndRates?.appliedReferral?.message}
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {propertyData?.is_available_for_booking == "reserving" && (
                  <>
                    <h2>{t("propertyDetail.availabilities")}</h2>
                    <div className="mb-4 mt-3">
                      <div className="date-range-container2 date-range-positionrel">
                        <DateRangePicker
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                          months={2}
                          minDate={new Date()}
                          disabledDates={reviewData?.reservedDates}
                          direction="vertical"
                          moveRangeOnFirstSelection={false}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="property_Shadow property_Shadow1">
                  <div className="pFlex">
                    <h3 className="ph3">
                      $
                      {propertyData?.weekend_discounted_price
                        ? propertyData?.weekend_discounted_price
                        : `$${propertyData?.price_for_weekends}`}
                      <span> / {t("propertyDetail.night")}</span>
                    </h3>
                    <div className="pFlexStar">
                      <Icon icon="ph:star" color="#1B91BF" fontSize={20} />
                      {formatRating(reviewData?.averageRating)}
                      <span className="dot"></span>
                      {reviews?.length > 1
                        ? `${reviews?.length} reviews`
                        : `${reviews?.length} review`}
                    </div>
                  </div>
                  {!isHost() && isAuthenticated() ? (
                    <>
                      <Button
                        className="w-100"
                        onClick={() => {
                          confirmBooking(
                            availabiltyDataAndRates?.appliedCoupon?.discountId,
                            availabiltyDataAndRates?.appliedCoupon
                              ?.discountAmount,
                            availabiltyDataAndRates?.totalAmount.toFixed(2)
                          );
                        }}
                        disabled={!isAvailableForBooking || isBooking}
                      >
                        {isBooking ? "Reserving" : "Reserve"}
                      </Button>
                      {!isAvailableForBooking && (
                        <p className="text-start errorStyle">
                          {t("propertyDetail.PropertyNotAvailable")}
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {isHost() && (
                        <>
                          {" "}
                          <Button
                            className="w-100"
                            onClick={() => setAccountAlert(true)}
                          >
                            {t("propertyDetail.LoginToReserve")}
                          </Button>
                          {!isAvailableForBooking && (
                            <p className="text-start errorStyle">
                              {t("propertyDetail.PropertyNotAvailable")}
                            </p>
                          )}
                        </>
                      )}
                      {!isHost() && (
                        <>
                          {" "}
                          <Button className="w-100" as={Link} to={"/login"}>
                            {t("propertyDetail.LoginToReserve")}
                          </Button>
                          {!isAvailableForBooking && (
                            <p className="text-start errorStyle">
                              {t("propertyDetail.PropertyNotAvailable")}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                  <p className="text-center">{t("propertyDetail.Youwon’tBeChargedYet")}</p>
                  <h5>
                    {
                      currentLanguage === "he" ?
                        <strong dir="rtl" style={{ unicodeBidi: "embed", direction: "rtl" }}>
                          {t("propertyDetail.nights")} {formatValues(availabiltyDataAndRates?.totalDays)} ×{" "}
                          {formatValues(availabiltyDataAndRates?.pricePerNight)}
                        </strong>
                        :
                        <strong>
                          ${formatValues(availabiltyDataAndRates?.pricePerNight)} x{" "}
                          {formatValues(availabiltyDataAndRates?.totalDays)} {t("propertyDetail.nights")}
                        </strong>
                    }



                    <span>
                      ${formatValues(availabiltyDataAndRates?.originalAmount)}
                    </span>
                  </h5>
                  <h5>
                    <strong>{t("propertyDetail.OfferedDiscount")}</strong>
                    <span className="minus">
                      -$
                      {
                        //  && availabiltyDataAndRates?.discount_type == ""
                        availabiltyDataAndRates?.appliedCoupon
                          ?.discountAmount || 0
                      }
                    </span>
                  </h5>

                  {availabiltyDataAndRates?.appliedReferral?.discountAmount >
                    0 && (
                      <h5>
                        <strong>
                          {t("propertyDetail.ReferralDiscount")}{" "}
                          <button
                            onClick={() => {
                              setreferralCodee("");
                              setf(!f);
                              setTimeout(() => {
                                getDateforProperty("");
                              }, 100);
                            }}
                            style={{
                              border: "none",
                              marginBottom: "20px !important",
                              outline: "none",
                              backgroundColor: "transparent",
                              color: "red",
                            }}
                          >
                            <Icon fontSize={20} icon="mdi:trash" color="red" />
                          </button>{" "}
                        </strong>
                        <span className="minus">
                          -$
                          {formatRating(
                            availabiltyDataAndRates?.appliedReferral
                              ?.discountAmount
                          ) || 0}
                        </span>
                      </h5>
                    )}

                  <div className="divider"></div>
                  <h5 className="mb-0">
                    <strong>{t("propertyDetail.Total")}</strong>
                    <span>
                      ${formatValues(availabiltyDataAndRates?.totalAmount)}
                    </span>
                  </h5>
                </div>
              </Col>
            ) : (
              <>
                <div className="property_Shadow property_Shadow1">
                  <h2 className="text-center">
                    {t("propertyDetail.PropertyReserved")}
                  </h2>
                  <p className="text-center">
                    {" "}
                    {t("propertyDetail.ContactOwner")}
                  </p>
                  <Button
                    className="w-80 text-center m-auto"
                    style={{ width: "80%" }}
                    onClick={() =>
                    (window.location.href =
                      "mailto:support@lanim.com?subject=Subject&body=Your message here")
                    }
                  >
                    {t("propertyDetail.ContactNow")}
                  </Button>

                  <h5 className="mt-3">
                    <strong> {t("propertyDetail.mobile")}</strong>
                    <span
                      className="minus"
                      style={{
                        position: "relative",
                        left: -3,
                      }}
                    >
                      {propertyData?.phone_number}
                    </span>
                  </h5>

                  <h5>
                    <strong>{t("propertyDetail.email")}</strong>
                    <span className="minus">
                      {localStorage.getItem("email") || "--"}
                    </span>
                  </h5>
                </div>
              </>
            )}
          </Row>

          <Row className="mb-4">
            <Col md={12}>
              <h2 className="mb-3 proH3">{t("propertyDetail.PropertyLocation")}</h2>
              <PropertyLocationMap
                containerStyle={{
                  width: "100%",
                  height: "600px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  marginBottom: "20px",
                  overflow: "hidden",
                }}
                latlon={propertyLocation}
              ></PropertyLocationMap>
            </Col>
          </Row>
        </Container>
      </section>

      <MyModel
        show={reportModel}
        title={t("report_property")}
        onHide={() => setReportModel(false)}
        id={propertyData.id}
      />

      <Modal
        size="lg"
        show={accountAlert}
        aria-labelledby="contained-modal-title-vcenter"
        onHide={() => setAccountAlert(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{
              textAlign: "center",
              color: "red",
              width: "100%",
            }}
          >
            {t("propertyDetail.alert!")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {t("propertyDetail.des")}
          </p>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default PropertyDetailScreen;
